export type SelectorSegment = string | number | null | undefined;

export const joinSelector = (...segments: SelectorSegment[]): string => segments
    .filter((segment) => segment !== null && segment !== undefined && segment !== '')
    .join('.');

const elementSegments = (
    element: SelectorSegment | readonly SelectorSegment[],
): readonly SelectorSegment[] => (typeof element === 'object' && element !== null ? element : [element]);

export const elementSelector = <Flat extends string | null | undefined>(
    path: string | null | undefined,
    element: SelectorSegment | readonly SelectorSegment[],
    flat: Flat,
): string | Flat => (path ? joinSelector(path, ...elementSegments(element)) : flat);
